"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldValidationMessage = exports.FieldMsg = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconConst = require("../icons/iconConst");

var _Transition = require("../animate/Transition");

var _fieldAttrsUtils = require("./fieldAttrsUtils");

var _fieldUtils = require("./fieldUtils");

var _FieldIconsDisplay = require("./FieldIconsDisplay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FieldMsg = function FieldMsg(_ref) {
  var showMessage = _ref.showMessage,
      type = _ref.type,
      id = _ref.id,
      hideValidationIcon = _ref.hideValidationIcon,
      message = _ref.message,
      iconId = _ref.iconId,
      validationProps = _ref.validationProps;
  var isInvalid = validationProps.isInvalid;
  var iconProps = {
    id: iconId,
    validationProps: validationProps
  };
  return _react.default.createElement(_Transition.Transition, null, showMessage && _react.default.createElement("span", {
    key: "".concat(type, "-").concat(id, "-").concat(isInvalid),
    className: "field-msg__content"
  }, !hideValidationIcon && _react.default.createElement(_FieldIconsDisplay.FieldValidationIcon, iconProps), _react.default.createElement("span", null, message)));
};

exports.FieldMsg = FieldMsg;
FieldMsg.defaultProps = {
  showMessage: false,
  hideValidationIcon: false,
  message: null
};
FieldMsg.propTypes = {
  id: _propTypes.default.string.isRequired,
  iconId: _propTypes.default.string.isRequired,
  showMessage: _propTypes.default.bool,
  type: _propTypes.default.string.isRequired,
  hideValidationIcon: _propTypes.default.bool,
  validationProps: _fieldUtils.validationPropsTypes.isRequired,
  message: _propTypes.default.string
};
/**
 * Containing (parent) element span purposefully left in the DOM
 * so aria-live will announce the children when a message changes/is added.
 * NOTE: Using aria-describedby only announces things when the field gains focus:
 * so don't use it with warning.
 */

var FieldValidationMessage = function FieldValidationMessage(_ref2) {
  var id = _ref2.id,
      validationProps = _ref2.validationProps,
      fieldName = _ref2.fieldName,
      isAssertive = _ref2.isAssertive,
      isWithCounter = _ref2.isWithCounter,
      hideValidationIcon = _ref2.hideValidationIcon;
  var isInvalid = validationProps.isInvalid,
      message = validationProps.message,
      showMessage = validationProps.showMessage,
      type = validationProps.type;
  var fieldIds = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  var errContainerProps = (0, _fieldAttrsUtils.errorMsgAttributes)({
    id: id,
    isAssertive: isAssertive
  });
  var warnContainerProps = (0, _fieldAttrsUtils.warningMsgAttributes)({
    isAssertive: isAssertive
  });
  var msgProps = {
    type: type,
    id: id,
    message: message,
    hideValidationIcon: hideValidationIcon,
    validationProps: validationProps
  };
  var hasMessage = showMessage && !!message;
  var showError = isInvalid && hasMessage;
  /* NEVER show the warning if there is an error - error is the priority */

  var showWarn = !isInvalid && hasMessage && type === _iconConst.WARNING;
  return _react.default.createElement("span", {
    className: isWithCounter ? 'field-counter-group-messages' : null
  }, _react.default.createElement("span", errContainerProps, _react.default.createElement(FieldMsg, _extends({
    showMessage: showError,
    iconId: fieldIds.icon.id
  }, msgProps))), _react.default.createElement("span", warnContainerProps, _react.default.createElement(FieldMsg, _extends({
    showMessage: showWarn,
    iconId: fieldIds.icon.id
  }, msgProps))));
};

exports.FieldValidationMessage = FieldValidationMessage;
FieldValidationMessage.defaultProps = {
  isAssertive: false,
  isWithCounter: false,
  hideValidationIcon: false
};
FieldValidationMessage.propTypes = {
  id: _propTypes.default.string.isRequired,
  fieldName: _propTypes.default.string.isRequired,
  validationProps: _fieldUtils.validationPropsTypes.isRequired,
  isAssertive: _propTypes.default.bool,
  isWithCounter: _propTypes.default.bool,
  hideValidationIcon: _propTypes.default.bool
};